<template>
  <section style="padding-top: 80px" class="package-form">
    <div class="bg-decoration">
      <div class="floating-shape shape-1"></div>
      <div class="floating-shape shape-2"></div>
      <div class="floating-shape shape-3"></div>
      <div class="gradient-orb orb-1"></div>
      <div class="gradient-orb orb-2"></div>
    </div>
    <v-container>
      <div class="form-header" style="padding-top: 30px">
        <div class="header-badge">
          <span class="badge-icon">✦</span>
          <span>Premium Service</span>
        </div>
        <h2 class="form-title"><span class="title-highlight">Package</span> Form</h2>
        <p class="form-subtitle">Experience excellence in home care services</p>
        <div class="progress-indicator">
          <div class="progress-step" :class="{ active: sectionsVisible[0] }">
            <div class="step-dot"></div>
            <span>Personal</span>
          </div>
          <div class="progress-line"></div>
          <div class="progress-step" :class="{ active: sectionsVisible[1] }">
            <div class="step-dot"></div>
            <span>Property</span>
          </div>
          <div class="progress-line"></div>
          <div class="progress-step" :class="{ active: sectionsVisible[2] }">
            <div class="step-dot"></div>
            <span>Contact</span>
          </div>
          <div class="progress-line"></div>
          <div class="progress-step" :class="{ active: sectionsVisible[3] }">
            <div class="step-dot"></div>
            <span>Services</span>
          </div>
          <div class="progress-line"></div>
          <div class="progress-step" :class="{ active: sectionsVisible[4] }">
            <div class="step-dot"></div>
            <span>Complete</span>
          </div>
        </div>
        <p
          style="
            padding: 18px 20px;
            margin: 16px 0;
            background: #fff4e5;
            border-left: 6px solid #ff8c00;
            color: #6b3b00;
            font-size: 15px;
            line-height: 1.4;
            border-radius: 6px;
          "
        >
          <strong style="display: inline-block; margin-right: 8px">Note:</strong>
          Please note that payments are accepted only in foreign currency.
        </p>
      </div>

      <v-form ref="form" v-model="valid" lazy-validation>
        <div class="form-section" :class="{ 'section-visible': sectionsVisible[0] }">
          <div class="section-header">
            <div class="section-icon-wrapper">
              <v-icon color="#f46523" size="28">mdi-account</v-icon>
              <div class="icon-glow"></div>
            </div>
            <div class="section-header-text">
              <h3 class="section-title">Personal Details</h3>
              <p class="section-subtitle">Tell us about yourself</p>
            </div>
            <div class="section-number">01</div>
          </div>
          <v-row>
            <v-col cols="12" md="6">
              <div class="field-wrapper">
                <v-text-field
                  label="Name"
                  v-model="form.name"
                  :rules="[rules.required]"
                  outlined
                  dense
                  color="#f46523"
                  prepend-inner-icon="mdi-account-outline"
                  class="animated-field premium-field"
                />
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="field-wrapper">
                <div class="d-flex align-center">
                  <v-select
                    v-model="form.countryCode"
                    :items="countryCodes"
                    outlined
                    dense
                    autocomplete
                    hide-details
                    style="max-width: 98px; margin-right: 8px; padding-bottom: 5px; font-size: 12px"
                    color="#f46523"
                    class="premium-field"
                    item-text="text"
                    item-value="value"
                  ></v-select>

                  <v-text-field
                    label="Phone"
                    v-model="form.phone"
                    :rules="[rules.required, rules.phone]"
                    type="tel"
                    outlined
                    @keypress="($event) => !/[0-9]/.test($event.key) && $event.preventDefault()"
                    dense
                    color="#f46523"
                    prepend-inner-icon="mdi-phone-outline"
                    class="animated-field premium-field flex-grow-1"
                    @input="form.phone = form.phone.replace(/\D/g, '')"
                  />
                </div>
              </div>
            </v-col>

            <v-col cols="12" md="6">
              <div class="field-wrapper">
                <v-text-field
                  label="Email"
                  v-model="form.email"
                  :rules="[rules.required, rules.email]"
                  outlined
                  dense
                  color="#f46523"
                  prepend-inner-icon="mdi-email-outline"
                  class="animated-field premium-field"
                />
              </div>
            </v-col>
          </v-row>
        </div>

        <div class="form-section" :class="{ 'section-visible': sectionsVisible[1] }">
          <div class="section-header">
            <div class="section-icon-wrapper">
              <v-icon color="#f46523" size="28">mdi-home</v-icon>
              <div class="icon-glow"></div>
            </div>
            <div class="section-header-text">
              <h3 class="section-title">Property Details</h3>
              <p class="section-subtitle">Where we'll serve you</p>
            </div>
            <div class="section-number">02</div>
          </div>
          <v-row>
            <v-col cols="12" md="6">
              <div class="field-wrapper">
                <v-textarea
                  label="Address"
                  v-model="form.address"
                  :rules="[rules.required]"
                  outlined
                  counter="150"
                  dense
                  color="#f46523"
                  prepend-inner-icon="mdi-map-marker-outline"
                  rows="3"
                  class="animated-field premium-field"
                />
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="field-wrapper">
                <v-text-field
                  label="Landmark"
                  color="#f46523"
                  v-model="form.landmark"
                  outlined
                  dense
                  prepend-inner-icon="mdi-map-marker-radius"
                  class="animated-field premium-field"
                />
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="field-wrapper">
                <v-text-field
  label="Pincode"
  v-model="form.pincode"
  :rules="[rules.required, rules.pincode]"
  outlined
  dense
  color="#f46523"
  prepend-inner-icon="mdi-mailbox-outline"
  class="animated-field premium-field"
  @keypress="($event) => !/[0-9]/.test($event.key) && $event.preventDefault()"
/>

              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="field-wrapper">
                <v-text-field
                  label="Approximate Square Feet"
                  v-model="form.squareFeet"
                  outlined
                  color="#f46523"
                  dense
                  prepend-inner-icon="mdi-ruler-square"
                  class="animated-field premium-field"
                />
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="field-wrapper">
                <v-select
                  label="Property Type"
                  :items="propertyTypes"
                  v-model="form.propertyType"
                  :rules="[rules.required]"
                  outlined
                  color="#f46523"
                  dense
                  prepend-inner-icon="mdi-office-building"
                  class="animated-field premium-field"
                />
              </div>
            </v-col>

            <v-col cols="12" md="6">
              <div class="field-wrapper">
                <v-select
                  label="State"
                  :items="states"
                  v-model="form.state"
                  :rules="[rules.required]"
                  outlined
                  color="#f46523"
                  dense
                  prepend-inner-icon="mdi-map-marker-outline"
                  class="animated-field premium-field"
                />
              </div>
            </v-col>

            <v-col cols="12" md="6">
              <div class="field-wrapper">
                <v-select
                  label="District"
                  :items="districts"
                  v-model="form.district"
                  :rules="[rules.required]"
                  outlined
                  color="#f46523"
                  dense
                  prepend-inner-icon="mdi-map-marker"
                  class="animated-field premium-field"
                />
              </div>
            </v-col>
          </v-row>
        </div>

        <div class="form-section" :class="{ 'section-visible': sectionsVisible[2] }">
          <div class="section-header">
            <div class="section-icon-wrapper">
              <v-icon color="#f46523" size="28">mdi-phone</v-icon>
              <div class="icon-glow"></div>
            </div>
            <div class="section-header-text">
              <h3 class="section-title">Point of Contact</h3>
              <p class="section-subtitle">
                Alternative contact person (Someone from the same household or property we can reach
                if the main contact is unavailable)
              </p>
            </div>
            <div class="section-number">03</div>
          </div>
          <v-row>
            <v-col cols="12" md="6">
              <div class="field-wrapper">
                <v-text-field
                  label="Contact Person Name"
                  color="#f46523"
                  v-model="form.contactName"
                  outlined
                  dense
                  prepend-inner-icon="mdi-account-circle-outline"
                  class="animated-field premium-field"
                />
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="field-wrapper">
                <v-text-field
                  color="#f46523"
                  label="Contact Person Phone"
                  v-model="form.contactPhone"
                  outlined
                  @keypress="($event) => !/[0-9]/.test($event.key) && $event.preventDefault()"
                  dense
                  prepend-inner-icon="mdi-cellphone"
                  class="animated-field premium-field"
                />
              </div>
            </v-col>
          </v-row>
        </div>
        <div class="form-section" :class="{ 'section-visible': sectionsVisible[4] }">
          <div class="section-header">
            <div class="section-icon-wrapper">
              <v-icon color="#f46523" size="28">mdi-note-text</v-icon>
              <div class="icon-glow"></div>
            </div>
            <div class="section-header-text">
              <h3 class="section-title">Special Instructions</h3>
              <p class="section-subtitle">Any special requirements</p>
            </div>
            <div class="section-number">05</div>
          </div>
          <v-row>
            <v-col cols="12" md="6">
              <div class="field-wrapper">
                <v-textarea
                  label="Special Care Instructions"
                  v-model="form.specialInstructions"
                  outlined
                  counter="150"
                  dense
                  color="#f46523"
                  rows="3"
                  prepend-inner-icon="mdi-alert-circle-outline"
                  class="animated-field premium-field"
                />
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="field-wrapper">
                <v-textarea
                  label="Additional Requirement"
                  v-model="form.additionalRequirement"
                  outlined
                  counter="150"
                  dense
                  color="#f46523"
                  rows="3"
                  prepend-inner-icon="mdi-plus-circle-outline"
                  class="animated-field premium-field"
                />
              </div>
            </v-col>
          </v-row>
        </div>

        <div class="text-center mt-6 submit-wrapper">
          <v-btn
            class="proceed-btn"
            color="#f46523"
            dark
            x-large
            @click="openTerms"
            :loading="submitting"
            :disabled="submitting"
          >
            <div class="btn-shine"></div>
            <v-icon left>mdi-check-circle</v-icon>
            <span class="btn-text">
              {{ submitting ? 'Submitting...' : 'Proceed' }}
            </span>
            <v-icon right size="20">mdi-arrow-right</v-icon>
          </v-btn>
          <p class="submit-note">Your information is secure and encrypted</p>
        </div>
      </v-form>

      <TermsModal
        ref="termsModal"
        @accepted="
          termsAccepted = true;
          submitForm();
        "
      />
      <ErrorToast :show="showError" :message="singleError" :progress="progress" />
    </v-container>
  </section>
</template>

<script>
import axios from 'axios';
import ErrorToast from '@/components/ErrorToast.vue';
import TermsModal from '@/components/TermsModal.vue';
import { submitPackageEnquiry, getPaymentForigner } from '@/services/planService.js';

const API_BASE_URL = 'https://live.ohyesworld.com';

export default {
  name: 'PackageFormView',
  components: { ErrorToast, TermsModal },
  data() {
    return {
      valid: false,
      showError: false,
      progress: 100,
      timer: null,
      singleError: '',
      termsAccepted: false,
      submitting: false,
      planId: this.$route.params.planId || '',
      services: this.$route.query.includes ? JSON.parse(this.$route.query.includes) : [],

      selectedServices: [],
      sectionsVisible: [false, false, false, false, false],
      form: {
        name: '',
        phone: '',
        email: '',
        countryCode: '+91',
        customerType: '',
        address: '',
        landmark: '',
        pincode: '',
        squareFeet: '',
        propertyType: '',
        contactName: '',
        contactPhone: '',
        regularService: '',
        state: '',
        district: '',
        specialInstructions: '',
        additionalRequirement: '',
      },
      customerTypes: ['Local Resident', 'NRI (Non-Resident-Indian)'],
      propertyTypes: ['Apartment', 'Villa', 'Independent House'],
      states: ['Kerala', 'Karnataka'],
      districtMap: {
        Kerala: [
          'Thiruvananthapuram',
          'Kollam',
          'Alappuzha',
          'Pathanamthitta',
          'Kottayam',
          'Idukki',
          'Ernakulam',
          'Thrissur',
          'Palakkad',
          'Malappuram',
          'Kozhikode',
          'Wayanad',
          'Kannur',
          'Kasaragod',
        ],
        Karnataka: ['Bangalore'],
      },

      countryCodes: [
        // Frequently Used
        { text: '🇮🇳 +91', value: '+91' }, // India
        { text: '🇦🇪 +971', value: '+971' }, // UAE
        { text: '🇺🇸 +1', value: '+1' }, // USA
        { text: '🇨🇦 +1', value: '+1' }, // Canada
        { text: '🇬🇧 +44', value: '+44' }, // UK
        { text: '🇦🇺 +61', value: '+61' }, // Australia

        // Gulf Countries (GCC)
        { text: '🇸🇦 +966', value: '+966' }, // Saudi Arabia
        { text: '🇶🇦 +974', value: '+974' }, // Qatar
        { text: '🇰🇼 +965', value: '+965' }, // Kuwait
        { text: '🇴🇲 +968', value: '+968' }, // Oman
        { text: '🇧🇭 +973', value: '+973' }, // Bahrain

        // Asia
        { text: '🇸🇬 +65', value: '+65' }, // Singapore
        { text: '🇲🇾 +60', value: '+60' }, // Malaysia
        { text: '🇵🇰 +92', value: '+92' }, // Pakistan
        { text: '🇧🇩 +880', value: '+880' }, // Bangladesh
        { text: '🇱🇰 +94', value: '+94' }, // Sri Lanka
        { text: '🇳🇵 +977', value: '+977' }, // Nepal
        { text: '🇲🇻 +960', value: '+960' }, // Maldives
        { text: '🇹🇭 +66', value: '+66' }, // Thailand
        { text: '🇮🇩 +62', value: '+62' }, // Indonesia
        { text: '🇵🇭 +63', value: '+63' }, // Philippines
        { text: '🇻🇳 +84', value: '+84' }, // Vietnam
        { text: '🇯🇵 +81', value: '+81' }, // Japan
        { text: '🇰🇷 +82', value: '+82' }, // South Korea
        { text: '🇨🇳 +86', value: '+86' }, // China
        { text: '🇭🇰 +852', value: '+852' }, // Hong Kong
        { text: '🇲🇴 +853', value: '+853' }, // Macau
        { text: '🇹🇼 +886', value: '+886' }, // Taiwan
        { text: '🇲🇲 +95', value: '+95' }, // Myanmar
        { text: '🇰🇭 +855', value: '+855' }, // Cambodia
        { text: '🇱🇦 +856', value: '+856' }, // Laos
        { text: '🇧🇳 +673', value: '+673' }, // Brunei
        { text: '🇰🇿 +7', value: '+7' }, // Kazakhstan
        { text: '🇺🇿 +998', value: '+998' }, // Uzbekistan
        { text: '🇹🇯 +992', value: '+992' }, // Tajikistan
        { text: '🇰🇬 +996', value: '+996' }, // Kyrgyzstan
        { text: '🇹🇲 +993', value: '+993' }, // Turkmenistan
        { text: '🇦🇫 +93', value: '+93' }, // Afghanistan
        { text: '🇮🇷 +98', value: '+98' }, // Iran
        { text: '🇮🇶 +964', value: '+964' }, // Iraq
        { text: '🇸🇾 +963', value: '+963' }, // Syria
        { text: '🇯🇴 +962', value: '+962' }, // Jordan
        { text: '🇱🇧 +961', value: '+961' }, // Lebanon
        { text: '🇮🇱 +972', value: '+972' }, // Israel
        { text: '🇵🇸 +970', value: '+970' }, // Palestine
        { text: '🇾🇪 +967', value: '+967' }, // Yemen
        { text: '🇦🇲 +374', value: '+374' }, // Armenia
        { text: '🇦🇿 +994', value: '+994' }, // Azerbaijan
        { text: '🇬🇪 +995', value: '+995' }, // Georgia
        { text: '🇹🇷 +90', value: '+90' }, // Turkey
        { text: '🇨🇾 +357', value: '+357' }, // Cyprus
        { text: '🇲🇳 +976', value: '+976' }, // Mongolia

        // Europe
        { text: '🇮🇪 +353', value: '+353' }, // Ireland
        { text: '🇩🇪 +49', value: '+49' }, // Germany
        { text: '🇫🇷 +33', value: '+33' }, // France
        { text: '🇪🇸 +34', value: '+34' }, // Spain
        { text: '🇮🇹 +39', value: '+39' }, // Italy
        { text: '🇵🇹 +351', value: '+351' }, // Portugal
        { text: '🇳🇱 +31', value: '+31' }, // Netherlands
        { text: '🇧🇪 +32', value: '+32' }, // Belgium
        { text: '🇱🇺 +352', value: '+352' }, // Luxembourg
        { text: '🇨🇭 +41', value: '+41' }, // Switzerland
        { text: '🇦🇹 +43', value: '+43' }, // Austria
        { text: '🇩🇰 +45', value: '+45' }, // Denmark
        { text: '🇸🇪 +46', value: '+46' }, // Sweden
        { text: '🇳🇴 +47', value: '+47' }, // Norway
        { text: '🇫🇮 +358', value: '+358' }, // Finland
        { text: '🇮🇸 +354', value: '+354' }, // Iceland
        { text: '🇵🇱 +48', value: '+48' }, // Poland
        { text: '🇨🇿 +420', value: '+420' }, // Czech Republic
        { text: '🇸🇰 +421', value: '+421' }, // Slovakia
        { text: '🇭🇺 +36', value: '+36' }, // Hungary
        { text: '🇷🇴 +40', value: '+40' }, // Romania
        { text: '🇧🇬 +359', value: '+359' }, // Bulgaria
        { text: '🇬🇷 +30', value: '+30' }, // Greece
        { text: '🇭🇷 +385', value: '+385' }, // Croatia
        { text: '🇸🇮 +386', value: '+386' }, // Slovenia
        { text: '🇷🇸 +381', value: '+381' }, // Serbia
        { text: '🇧🇦 +387', value: '+387' }, // Bosnia and Herzegovina
        { text: '🇲🇪 +382', value: '+382' }, // Montenegro
        { text: '🇲🇰 +389', value: '+389' }, // North Macedonia
        { text: '🇦🇱 +355', value: '+355' }, // Albania
        { text: '🇽🇰 +383', value: '+383' }, // Kosovo
        { text: '🇪🇪 +372', value: '+372' }, // Estonia
        { text: '🇱🇻 +371', value: '+371' }, // Latvia
        { text: '🇱🇹 +370', value: '+370' }, // Lithuania
        { text: '🇧🇾 +375', value: '+375' }, // Belarus
        { text: '🇺🇦 +380', value: '+380' }, // Ukraine
        { text: '🇷🇺 +7', value: '+7' }, // Russia
        { text: '🇲🇩 +373', value: '+373' }, // Moldova
        { text: '🇲🇹 +356', value: '+356' }, // Malta

        // Africa
        { text: '🇪🇬 +20', value: '+20' }, // Egypt
        { text: '🇿🇦 +27', value: '+27' }, // South Africa
        { text: '🇳🇬 +234', value: '+234' }, // Nigeria
        { text: '🇰🇪 +254', value: '+254' }, // Kenya
        { text: '🇪🇹 +251', value: '+251' }, // Ethiopia
        { text: '🇬🇭 +233', value: '+233' }, // Ghana
        { text: '🇹🇿 +255', value: '+255' }, // Tanzania
        { text: '🇺🇬 +256', value: '+256' }, // Uganda
        { text: '🇷🇼 +250', value: '+250' }, // Rwanda
        { text: '🇲🇦 +212', value: '+212' }, // Morocco
        { text: '🇩🇿 +213', value: '+213' }, // Algeria
        { text: '🇹🇳 +216', value: '+216' }, // Tunisia
        { text: '🇱🇾 +218', value: '+218' }, // Libya
        { text: '🇸🇩 +249', value: '+249' }, // Sudan
        { text: '🇸🇸 +211', value: '+211' }, // South Sudan
        { text: '🇸🇴 +252', value: '+252' }, // Somalia
        { text: '🇩🇯 +253', value: '+253' }, // Djibouti
        { text: '🇪🇷 +291', value: '+291' }, // Eritrea
        { text: '🇲🇿 +258', value: '+258' }, // Mozambique
        { text: '🇿🇼 +263', value: '+263' }, // Zimbabwe
        { text: '🇿🇲 +260', value: '+260' }, // Zambia
        { text: '🇲🇼 +265', value: '+265' }, // Malawi
        { text: '🇧🇼 +267', value: '+267' }, // Botswana
        { text: '🇳🇦 +264', value: '+264' }, // Namibia
        { text: '🇦🇴 +244', value: '+244' }, // Angola
        { text: '🇨🇲 +237', value: '+237' }, // Cameroon
        { text: '🇨🇩 +243', value: '+243' }, // DR Congo
        { text: '🇨🇬 +242', value: '+242' }, // Congo
        { text: '🇬🇦 +241', value: '+241' }, // Gabon
        { text: '🇹🇩 +235', value: '+235' }, // Chad
        { text: '🇨🇫 +236', value: '+236' }, // Central African Republic
        { text: '🇧🇯 +229', value: '+229' }, // Benin
        { text: '🇹🇬 +228', value: '+228' }, // Togo
        { text: '🇨🇮 +225', value: '+225' }, // Ivory Coast
        { text: '🇧🇫 +226', value: '+226' }, // Burkina Faso
        { text: '🇳🇪 +227', value: '+227' }, // Niger
        { text: '🇲🇱 +223', value: '+223' }, // Mali
        { text: '🇲🇷 +222', value: '+222' }, // Mauritania
        { text: '🇸🇳 +221', value: '+221' }, // Senegal
        { text: '🇬🇲 +220', value: '+220' }, // Gambia
        { text: '🇬🇳 +224', value: '+224' }, // Guinea
        { text: '🇬🇼 +245', value: '+245' }, // Guinea-Bissau
        { text: '🇸🇱 +232', value: '+232' }, // Sierra Leone
        { text: '🇱🇷 +231', value: '+231' }, // Liberia
        { text: '🇲🇺 +230', value: '+230' }, // Mauritius
        { text: '🇸🇨 +248', value: '+248' }, // Seychelles
        { text: '🇲🇬 +261', value: '+261' }, // Madagascar
        { text: '🇰🇲 +269', value: '+269' }, // Comoros
        { text: '🇱🇸 +266', value: '+266' }, // Lesotho
        { text: '🇸🇿 +268', value: '+268' }, // Eswatini

        // Oceania
        { text: '🇳🇿 +64', value: '+64' }, // New Zealand
        { text: '🇫🇯 +679', value: '+679' }, // Fiji
        { text: '🇵🇬 +675', value: '+675' }, // Papua New Guinea
        { text: '🇸🇧 +677', value: '+677' }, // Solomon Islands
        { text: '🇻🇺 +678', value: '+678' }, // Vanuatu
        { text: '🇳🇨 +687', value: '+687' }, // New Caledonia
        { text: '🇵🇫 +689', value: '+689' }, // French Polynesia
        { text: '🇼🇸 +685', value: '+685' }, // Samoa
        { text: '🇹🇴 +676', value: '+676' }, // Tonga
        { text: '🇰🇮 +686', value: '+686' }, // Kiribati
        { text: '🇹🇻 +688', value: '+688' }, // Tuvalu
        { text: '🇳🇷 +674', value: '+674' }, // Nauru
        { text: '🇵🇼 +680', value: '+680' }, // Palau
        { text: '🇫🇲 +691', value: '+691' }, // Micronesia
        { text: '🇲🇭 +692', value: '+692' }, // Marshall Islands

        // North America
        { text: '🇲🇽 +52', value: '+52' }, // Mexico
        { text: '🇬🇹 +502', value: '+502' }, // Guatemala
        { text: '🇧🇿 +501', value: '+501' }, // Belize
        { text: '🇸🇻 +503', value: '+503' }, // El Salvador
        { text: '🇭🇳 +504', value: '+504' }, // Honduras
        { text: '🇳🇮 +505', value: '+505' }, // Nicaragua
        { text: '🇨🇷 +506', value: '+506' }, // Costa Rica
        { text: '🇵🇦 +507', value: '+507' }, // Panama

        // Caribbean
        { text: '🇯🇲 +1876', value: '+1876' }, // Jamaica
        { text: '🇹🇹 +1868', value: '+1868' }, // Trinidad and Tobago
        { text: '🇧🇧 +1246', value: '+1246' }, // Barbados
        { text: '🇧🇸 +1242', value: '+1242' }, // Bahamas
        { text: '🇩🇴 +1809', value: '+1809' }, // Dominican Republic
        { text: '🇭🇹 +509', value: '+509' }, // Haiti
        { text: '🇨🇺 +53', value: '+53' }, // Cuba
        { text: '🇵🇷 +1787', value: '+1787' }, // Puerto Rico
        { text: '🇬🇩 +1473', value: '+1473' }, // Grenada
        { text: '🇱🇨 +1758', value: '+1758' }, // Saint Lucia
        { text: '🇻🇨 +1784', value: '+1784' }, // Saint Vincent
        { text: '🇦🇬 +1268', value: '+1268' }, // Antigua and Barbuda
        { text: '🇩🇲 +1767', value: '+1767' }, // Dominica
        { text: '🇰🇳 +1869', value: '+1869' }, // Saint Kitts and Nevis

        // South America
        { text: '🇧🇷 +55', value: '+55' }, // Brazil
        { text: '🇦🇷 +54', value: '+54' }, // Argentina
        { text: '🇨🇱 +56', value: '+56' }, // Chile
        { text: '🇨🇴 +57', value: '+57' }, // Colombia
        { text: '🇵🇪 +51', value: '+51' }, // Peru
        { text: '🇻🇪 +58', value: '+58' }, // Venezuela
        { text: '🇪🇨 +593', value: '+593' }, // Ecuador
        { text: '🇧🇴 +591', value: '+591' }, // Bolivia
        { text: '🇵🇾 +595', value: '+595' }, // Paraguay
        { text: '🇺🇾 +598', value: '+598' }, // Uruguay
        { text: '🇬🇾 +592', value: '+592' }, // Guyana
        { text: '🇸🇷 +597', value: '+597' }, // Suriname
        { text: '🇬🇫 +594', value: '+594' }, // French Guiana
      ],
      // services: [
      //   'House Cleaning Services',
      //   'Bathroom Cleaning',
      //   'Window Cleaning',
      //   'Furniture',
      //   'Appliance Maintenance',
      //   'Kitchen Deep Cleaning',
      //   'Floor Mapping',
      //   'Carpet Cleaning',
      //   'Balcony Cleaning',
      //   'Garden Maintenance',
      //   'Water Tank Cleaning',
      // ],
      rules: {
        required: (v) => !!v || 'This field is required',
        email: (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        pincode: (v) => /^\d{6}$/.test(v) || 'Pincode must be exactly 6 digits',
      },
    };
  },
  computed: {
    isAllSelected() {
      return this.selectedServices.length === this.services.length;
    },
    isIndeterminate() {
      return this.selectedServices.length > 0 && !this.isAllSelected;
    },

    districts() {
      return this.districtMap[this.form.state] || [];
    },
  },

  watch: {
    'form.state'() {
      this.form.district = ''; // reset when user switches state
    },
  },

  methods: {
    toggleSelectAll() {
      if (this.isAllSelected) {
        this.selectedServices = [];
      } else {
        this.selectedServices = [...this.services];
      }
    },

    openTerms() {
      if (this.$refs.form.validate()) {
        this.$refs.termsModal.open();
      } else {
        this.findFirstError();
        this.triggerError();
      }
    },

    async submitPackageForm(formData) {
      try {
        const response = await axios.post(
          `${API_BASE_URL}/membership-plans/website/add-enquiry`,
          formData,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );
        return response.data;
      } catch (error) {
        console.error('Error submitting package form:', error);
        throw error;
      }
    },
    async submitForm() {
      this.submitting = true;
      try {
        const submissionData = {
          planId: this.planId,
          personalDetails: {
            name: this.form.name,
            phone: this.form.phone,
            countryCode: `${this.form.countryCode}`,
            email: this.form.email,
            customerType: this.form.customerType,
          },
          propertyDetails: {
            address: this.form.address,
            landmark: this.form.landmark || '',
            pincode: this.form.pincode,
            propertyType: this.form.propertyType,
            squareFeet: this.form.squareFeet || '',
            state: this.form.state,
            district: this.form.district,
          },
          contactPerson: {
            name: this.form.contactName || '',
            phone: this.form.contactPhone || '',
          },
          serviceRequirements: {
            selectedServices: this.selectedServices,
            regularServices: this.form.regularService || '',
          },
          specialInstructions: {
            cleaningInstructions: this.form.specialInstructions || '',
            additionalRequirements: this.form.additionalRequirement || '',
          },
        };
        const response = await submitPackageEnquiry(submissionData);
        if (response.error_code === 0) {
          const enquiryId = response.data;
          console.log(' Enquiry added successfully. ID:', enquiryId);
          const paymentResponse = await getPaymentForigner(enquiryId);
          console.log('Payment Response:', paymentResponse);
          const shortUrl = paymentResponse?.data?.paymentInfo?.short_url;
          if (shortUrl) {
            window.location.href = shortUrl;
          } else {
            this.singleError = 'Payment link not available. Please try again.';
            this.triggerError();
          }
        } else {
          this.singleError = response.message || 'Failed to submit enquiry.';
          this.triggerError();
        }
      } catch (error) {
        console.error('Form submission error:', error);
        this.singleError =
          error.response?.data?.message || 'Network or server error. Please try again.';
        this.triggerError();
      } finally {
        this.submitting = false;
      }
    },

    findFirstError() {
      if (!this.form.name) this.singleError = 'Name is required.';
      else if (!this.form.phone) this.singleError = 'Phone is required.';
      else if (!this.form.email) this.singleError = 'Email is required.';
      else if (!/.+@.+\..+/.test(this.form.email)) this.singleError = 'Email must be valid.';
      else if (!this.form.address) this.singleError = 'Complete address is required.';
      else if (!/^\d{10}$/.test(this.form.contactPhone))
        this.singleError = 'Phone number for contact must be 10 digits.';
      else if (!this.form.pincode) this.singleError = 'Pincode is required.';
      else if (!/^\d{6}$/.test(this.form.pincode))
  this.singleError = 'Pincode must be exactly 6 digits.';
      else if (!this.form.propertyType) this.singleError = 'Property type is required.';
      else if (!this.form.state) this.singleError = 'State is required.';
      else if (!this.form.district) this.singleError = 'District is required.';
      else this.singleError = 'Please fix the errors before submitting.';
    },

    triggerError() {
      this.showError = true;
      this.progress = 100;
      if (this.timer) clearInterval(this.timer);

      this.timer = setInterval(() => {
        if (this.progress > 0) {
          this.progress -= 5;
        } else {
          this.showError = false;
          clearInterval(this.timer);
        }
      }, 100);
    },

    showSuccess() {
      this.showError = true;
      this.progress = 100;
      if (this.timer) clearInterval(this.timer);

      this.timer = setInterval(() => {
        if (this.progress > 0) {
          this.progress -= 2.5;
        } else {
          this.showError = false;
          clearInterval(this.timer);
        }
      }, 100);
    },

    animateSections() {
      this.sectionsVisible.forEach((_, index) => {
        setTimeout(() => {
          this.$set(this.sectionsVisible, index, true);
        }, index * 150);
      });
    },
  },

  mounted() {
    if (!this.planId) {
      console.warn('Plan ID not found. Make sure to pass it via route params or props.');
    }

    setTimeout(() => {
      this.animateSections();
    }, 100);
  },

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
</script>

<style scoped>
.package-form {
  background: linear-gradient(135deg, #fafafa 0%, #ffffff 50%, #fff5f0 100%);
  padding: 40px 0;
  font-family: 'Nunito Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
}

.bg-decoration {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: hidden;
}

.floating-shape {
  position: absolute;
  border-radius: 50%;
  opacity: 0.03;
  animation: float 20s infinite ease-in-out;
}

.shape-1 {
  width: 400px;
  height: 400px;
  background: #f46523;
  top: -100px;
  left: -100px;
  animation-delay: 0s;
}

.shape-2 {
  width: 300px;
  height: 300px;
  background: #ff9800;
  bottom: -50px;
  right: -50px;
  animation-delay: -7s;
}

.shape-3 {
  width: 250px;
  height: 250px;
  background: #f46523;
  top: 50%;
  right: 10%;
  animation-delay: -14s;
}

.gradient-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.15;
  animation: pulse-glow 8s infinite ease-in-out;
}

.orb-1 {
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, #f46523, transparent);
  top: -200px;
  right: -200px;
}

.orb-2 {
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, #ff9800, transparent);
  bottom: -150px;
  left: -150px;
  animation-delay: -4s;
}

@keyframes float {
  0%,
  100% {
    transform: translate(0, 0) rotate(0deg);
  }
  25% {
    transform: translate(50px, -50px) rotate(90deg);
  }
  50% {
    transform: translate(0, -100px) rotate(180deg);
  }
  75% {
    transform: translate(-50px, -50px) rotate(270deg);
  }
}

@keyframes pulse-glow {
  0%,
  100% {
    opacity: 0.15;
    transform: scale(1);
  }
  50% {
    opacity: 0.25;
    transform: scale(1.1);
  }
}

.form-header {
  text-align: center;
  margin-bottom: 40px;
  animation: fadeInDown 0.8s ease-out;
  position: relative;
  z-index: 2;
}

.header-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, rgba(244, 101, 35, 0.1), rgba(255, 152, 0, 0.1));
  border: 2px solid rgba(244, 101, 35, 0.2);
  padding: 8px 20px;
  border-radius: 50px;
  font-size: 14px;
  font-weight: 700;
  color: #f46523;
  margin-bottom: 20px;
  animation: badge-pulse 2s infinite;
}

.badge-icon {
  animation: rotate 4s linear infinite;
}

@keyframes badge-pulse {
  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(244, 101, 35, 0.4);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 0 20px 10px rgba(244, 101, 35, 0);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.form-title {
  font-size: 48px;
  font-weight: 900;
  color: #333;
  margin-bottom: 12px;
  letter-spacing: -1px;
}

.title-highlight {
  background: linear-gradient(135deg, #f46523, #ff9800);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  position: relative;
}

.form-subtitle {
  font-size: 18px;
  color: #666;
  font-weight: 400;
  margin-bottom: 35px;
}

.progress-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  max-width: 700px;
  margin: 0 auto;
  padding: 20px;
  background: white;
  border-radius: 50px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

.progress-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  transition: all 0.4s ease;
}

.progress-step span {
  font-size: 11px;
  font-weight: 600;
  color: #999;
  transition: all 0.4s ease;
}

.step-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #e0e0e0;
  transition: all 0.4s ease;
  position: relative;
}

.progress-step.active .step-dot {
  background: linear-gradient(135deg, #f46523, #ff9800);
  box-shadow: 0 0 20px rgba(244, 101, 35, 0.5);
  transform: scale(1.3);
}

.progress-step.active .step-dot::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #f46523;
  opacity: 0.3;
  animation: ping 1.5s cubic-bezier(0, 0, 0.2, 1) infinite;
}

@keyframes ping {
  75%,
  100% {
    transform: translate(-50%, -50%) scale(2);
    opacity: 0;
  }
}

.progress-step.active span {
  color: #f46523;
  font-weight: 700;
}

.progress-line {
  width: 40px;
  height: 2px;
  background: #e0e0e0;
}

.form-section {
  background: white;
  border-radius: 24px;
  padding: 35px;
  margin-bottom: 24px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(244, 101, 35, 0.08);
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 0;
  transform: translateY(40px);
  position: relative;
  overflow: hidden;
}

.form-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, #f46523, #ff9800, #f46523);
  background-size: 200% 100%;
  animation: gradient-shift 3s linear infinite;
  opacity: 0;
  transition: opacity 0.4s ease;
}

.form-section:hover::before {
  opacity: 1;
}

@keyframes gradient-shift {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 200% 50%;
  }
}

.form-section.section-visible {
  opacity: 1;
  transform: translateY(0);
}

.form-section:hover {
  border-color: rgba(244, 101, 35, 0.25);
  box-shadow: 0 12px 40px rgba(244, 101, 35, 0.12);
  transform: translateY(-4px);
}

.section-header {
  display: flex;
  align-items: center;
  gap: 18px;
  margin-bottom: 28px;
  position: relative;
}

.section-icon-wrapper {
  position: relative;
  background: linear-gradient(135deg, rgba(244, 101, 35, 0.15), rgba(255, 152, 0, 0.15));
  width: 60px;
  height: 60px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s ease;
}

.form-section:hover .section-icon-wrapper {
  transform: rotate(5deg) scale(1.05);
}

.icon-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(244, 101, 35, 0.3), transparent);
  filter: blur(20px);
  animation: pulse 2s infinite;
  opacity: 0;
  transition: opacity 0.4s ease;
}

.form-section:hover .icon-glow {
  opacity: 1;
}

.section-header-text {
  flex: 1;
}

.section-title {
  color: #222;
  font-size: 26px;
  font-weight: 800;
  margin: 0 0 4px 0;
  letter-spacing: -0.5px;
}

.section-subtitle {
  color: #888;
  font-size: 14px;
  margin: 0;
  font-weight: 500;
}

.section-number {
  font-size: 48px;
  font-weight: 900;
  color: rgba(244, 101, 35, 0.08);
  line-height: 1;
  transition: all 0.4s ease;
}

.form-section:hover .section-number {
  color: rgba(244, 101, 35, 0.15);
  transform: scale(1.1);
}

.field-wrapper {
  position: relative;
}

.premium-field {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.premium-field:focus-within {
  transform: translateY(-3px);
}

:deep(.premium-field .v-input__slot) {
  background: #fafafa !important;
  transition: all 0.3s ease;
}

:deep(.premium-field:focus-within .v-input__slot) {
  background: white !important;
  box-shadow: 0 8px 25px rgba(244, 101, 35, 0.12) !important;
}

:deep(.v-text-field__details) {
  padding-top: 2px;
  margin-bottom: -4px;
}

:deep(.v-text-field--outlined fieldset) {
  border-width: 2px;
  border-color: #e8e8e8;
  transition: all 0.3s ease;
}

:deep(.v-input--is-focused fieldset) {
  border-color: #f46523 !important;
  border-width: 2px !important;
}

:deep(.premium-field .v-icon) {
  transition: all 0.3s ease;
}

:deep(.premium-field:focus-within .v-icon) {
  color: #f46523 !important;
  transform: scale(1.1);
}

.premium-checkbox-group {
  background: linear-gradient(135deg, #fafafa, #ffffff);
  border-radius: 16px;
  padding: 20px;
  border: 2px solid rgba(244, 101, 35, 0.1);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
}

.premium-checkbox-group:hover {
  border-color: rgba(244, 101, 35, 0.2);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06);
}

.select-all-wrapper {
  background: linear-gradient(135deg, rgba(244, 101, 35, 0.08), rgba(255, 152, 0, 0.08));
  border-radius: 12px;
  padding: 8px 12px;
  margin-bottom: 12px;
}

.elegant-divider {
  margin: 12px 0;
  background: linear-gradient(90deg, transparent, rgba(244, 101, 35, 0.2), transparent);
  height: 1px;
}

.services-grid {
  display: grid;
  gap: 4px;
}

.service-item {
  position: relative;
  background: white;
  border-radius: 10px;
  padding: 2px 8px;
  transition: all 0.3s ease;
  border: 1px solid transparent;
}

.service-item:hover {
  background: linear-gradient(135deg, rgba(244, 101, 35, 0.05), rgba(255, 152, 0, 0.05));
  border-color: rgba(244, 101, 35, 0.15);
  transform: translateX(4px);
}

.service-checkmark {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%) scale(0);
  color: #f46523;
  font-size: 18px;
  font-weight: 700;
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  pointer-events: none;
}

.service-item:has(:deep(.v-input--is-label-active)) .service-checkmark {
  transform: translateY(-50%) scale(1);
  opacity: 1;
}
:deep(.premium-checkbox .v-input--selection-controls) {
  margin-top: 0px !important;
  padding-top: 0px !important;
  margin-bottom: 0px !important;
}

:deep(.premium-checkbox .v-input__slot) {
  min-height: 15px !important;
  padding: 0 !important;
  margin-bottom: 0 !important;
}

:deep(.premium-checkbox .v-input__control) {
  min-height: 15px !important;
}

:deep(.premium-checkbox .v-label) {
  font-weight: 600;
  color: #444;
  transition: all 0.3s ease;
}

:deep(.premium-checkbox:hover .v-label) {
  color: #f46523;
}

:deep(.v-input--selection-controls__ripple) {
  transition: all 0.3s ease;
}

.submit-wrapper {
  margin-top: 40px;
  animation: fadeInUp 0.8s ease-out 0.6s both;
}

.proceed-btn {
  background: linear-gradient(135deg, #f46523, #ff9800) !important;
  color: white;
  padding: 18px 60px !important;
  border-radius: 50px;
  font-size: 18px;
  font-weight: 800;
  border: none;
  cursor: pointer;
  box-shadow: 0 10px 35px rgba(244, 101, 35, 0.35);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  text-transform: none !important;
  overflow: hidden;
  letter-spacing: 0.3px;
}

.btn-shine {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  transition: left 0.6s;
}

.proceed-btn:hover:not(:disabled) .btn-shine {
  left: 100%;
}

.proceed-btn:hover:not(:disabled) {
  transform: translateY(-6px) scale(1.03);
  box-shadow: 0 20px 50px rgba(244, 101, 35, 0.45);
}

.proceed-btn:active:not(:disabled) {
  transform: translateY(-3px) scale(1.01);
}

.proceed-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.btn-text {
  position: relative;
  z-index: 1;
}

.submit-note {
  margin-top: 16px;
  font-size: 13px;
  color: #888;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.submit-note::before {
  content: '🔒';
  font-size: 14px;
}

:deep(.v-list-item) {
  font-family: 'Nunito Sans', sans-serif !important;
  font-size: 15px;
  font-weight: 600;
  color: #444;
  transition: all 0.3s ease;
  border-radius: 8px;
  margin: 2px 0;
}

:deep(.v-list-item:hover) {
  background: linear-gradient(135deg, rgba(244, 101, 35, 0.1), rgba(255, 152, 0, 0.1)) !important;
  transform: translateX(4px);
  color: #f46523 !important;
}

:deep(.v-list-item.v-item--active) {
  background: linear-gradient(135deg, #f46523, #ff9800) !important;
  color: white !important;
  font-weight: 700;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
}

html {
  scroll-behavior: smooth;
}

@media (max-width: 960px) {
  .form-title {
    font-size: 36px;
  }

  .form-section {
    padding: 25px 20px;
  }

  .section-title {
    font-size: 22px;
  }

  .section-number {
    font-size: 36px;
  }

  .proceed-btn {
    padding: 16px 40px !important;
    font-size: 16px;
  }

  .progress-indicator {
    flex-wrap: wrap;
    gap: 10px;
  }

  .progress-step span {
    font-size: 10px;
  }

  .progress-line {
    display: none;
  }

  .floating-shape {
    display: none;
  }
}

@media (max-width: 600px) {
  .form-title {
    font-size: 28px;
  }

  .header-badge {
    font-size: 12px;
    padding: 6px 16px;
  }

  .form-subtitle {
    font-size: 14px;
  }

  .section-icon-wrapper {
    width: 50px;
    height: 50px;
  }

  .section-title {
    font-size: 20px;
  }

  .section-number {
    font-size: 28px;
  }
}

::-webkit-scrollbar {
  width: 12px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #f46523, #ff9800);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #e65522, #f59700);
}

@media (max-width: 600px) {
  :deep(.v-col) {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }

  /* Reduce form section padding */
  .form-section {
    padding: 16px 12px !important;
    margin-bottom: 12px;
  }

  /* Remove field wrapper margins */
  .field-wrapper {
    margin-bottom: 0 !important;
    margin-top: 0 !important;
  }

  /* Minimize text field details spacing */
  :deep(.v-text-field__details) {
    padding-top: 0px !important;
    margin-bottom: -4px !important;
    min-height: 0px !important;
    display: none !important; /* Hide completely when no errors */
  }

  /* Remove input control margins */
  :deep(.v-input__control) {
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
  }

  /* Minimize messages padding */
  :deep(.v-messages) {
    min-height: 0px !important;
    padding-top: 0px !important;
    display: none; /* Hide when empty */
  }

  /* Show messages only when there's an error */
  :deep(.v-input--has-state .v-messages) {
    display: block !important;
    min-height: 14px !important;
    padding-top: 2px !important;
  }

  :deep(.v-input--has-state .v-text-field__details) {
    display: block !important;
    min-height: 14px !important;
  }

  /* Very tight row spacing */
  :deep(.row) {
    margin-top: -2px !important;
    margin-bottom: -2px !important;
  }

  /* Reduce section header margin */
  .section-header {
    margin-bottom: 12px !important;
  }

  /* Reduce input slot margins */
  :deep(.v-input__slot) {
    margin-bottom: 0 !important;
  }

  /* Compact textarea */
  :deep(.v-textarea .v-text-field__slot) {
    margin-bottom: 0 !important;
  }

  /* Reduce outlined field padding */
  :deep(.v-text-field--outlined .v-input__control) {
    padding-bottom: 0 !important;
  }

  /* Reduce select dropdown spacing */
  :deep(.v-select__selections) {
    padding-bottom: 0 !important;
  }
}

/* For very small screens - ultra compact */
@media (max-width: 400px) {
  :deep(.v-col) {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }

  .form-section {
    padding: 12px 10px !important;
    margin-bottom: 10px !important;
  }

  :deep(.row) {
    margin-top: -14px !important;
    margin-bottom: -14px !important;
  }

  .section-header {
    margin-bottom: 10px !important;
  }

  /* Make inputs slightly smaller */
  :deep(.v-text-field--outlined.v-input--dense .v-label) {
    font-size: 14px !important;
  }
}

/* Compact spacing adjustments */
.form-section {
  padding: 25px !important;
}

.section-header {
  margin-bottom: 18px !important;
}

:deep(.v-row) {
  margin-top: -12px !important;
  margin-bottom: -12px !important;
}

:deep(.v-col) {
  padding-top: 6px !important;
  padding-bottom: 6px !important;
}

:deep(.v-text-field__details) {
  margin-bottom: -12px !important;
}
</style>
